import React from 'react';
import { actions, useTypedDispatch } from '../../../redux';
import { AssetDetails } from '../common/AssetDetails';

export const Details = () => {
    const dispatch = useTypedDispatch();

    return (
        <AssetDetails
            metadata
            editable='comment'
            onChange={() => (dispatch(actions.asset.commit()), dispatch(actions.asset.update()))}
        />
    );
};
